function splitMenuColumns() {
  const menu = document.querySelector( '.mega-products .mega-menu-column .mega-menu-item-has-children > ul' );
  if ( !menu ) return;

  if ( document.querySelector( '.mega-menu-wrapper' ) ) return;

  const items = Array.from( menu.children );
  const col1 = document.createElement( 'ul' );
  col1.className = 'mega-menu-col col1';
  const col2 = document.createElement( 'ul' );
  col2.className = 'mega-menu-col col2';

  items.forEach( item => {
    if ( item.classList.contains( 'mega-menu-item-has-children' ) ) {
      col2.appendChild( item );
    } else {
      col1.appendChild( item );
    }
  } );

  const wrapper = document.createElement( 'div' );
  wrapper.className = 'mega-menu-wrapper';
  wrapper.appendChild( col1 );
  wrapper.appendChild( col2 );
  menu.replaceWith( wrapper );
}

function mergeMenuColumns() {
  const wrapper = document.querySelector( '.mega-menu-wrapper' );
  if ( !wrapper ) return;

  const menu = document.createElement( 'ul' );
  menu.className = 'mega-menu';
  wrapper.querySelectorAll( 'li' ).forEach( li => menu.appendChild( li ) );
  wrapper.replaceWith( menu );
}

function handleMenuColumns() {
  if ( window.innerWidth >= 1200 ) {
    if ( !document.querySelector( '.mega-menu-wrapper' ) ) {
      splitMenuColumns();
    }
  } else {
    if ( document.querySelector( '.mega-menu-wrapper' ) ) {
      mergeMenuColumns();
    }
  }
}

handleMenuColumns();
window.addEventListener( 'resize', handleMenuColumns );